// src/salesAssessment/SalesAssessmentReportModal.js
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Typography,
  Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';
import { useTranslation } from 'react-i18next';
import SalesAssessmentReportContent from './SalesAssessmentReportContent';

export default function SalesAssessmentReportModal({ open, onClose, test }) {
  const { t } = useTranslation();
  const showEmpty = !test;
  const hasReportUrl = test?.reportUrl;

  const handleDownloadPDF = async () => {
    if (!hasReportUrl) return;

    try {
      const response = await fetch(test.reportUrl);
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = `${t('salesAssessment.reportModal.fileNamePrefix')}${test.applicantName || t('salesAssessment.reportModal.defaultFileName')}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error('Error downloading PDF:', error);
      window.open(test.reportUrl, '_blank');
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography variant="h6">
            {`${t('salesAssessment.reportModal.title')}${test?.applicantName ? ` - ${test.applicantName}` : ''}`}
          </Typography>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent dividers>
        {showEmpty ? (
          <Typography variant="body2" color="text.secondary">
            {t('salesAssessment.reportModal.noDataAvailable')}
          </Typography>
        ) : (
          <SalesAssessmentReportContent data={test} />
        )}
      </DialogContent>

      <DialogActions>
        <Button
          startIcon={<DownloadIcon />}
          variant="outlined"
          onClick={handleDownloadPDF}
          disabled={!hasReportUrl}
        >
          {t('salesAssessment.reportModal.downloadPDF')}
        </Button>
        <Button onClick={onClose}>
          {t('salesAssessment.reportModal.close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}